document.addEventListener('DOMContentLoaded', () => {
  const target = document.getElementById('template--30469713658195__scrolling_banner_Le7Nrk');
  if (!target) return;

  target.style.position = 'relative';
  target.style.overflow = 'hidden';

  const overlayBack = document.createElement('div');
  overlayBack.className = 'volta-mobiles-overlay volta-mobiles-overlay--back';
  overlayBack.innerHTML = `
    <div class="volta-pala volta-pala--cuzco2">
      <img src="${window.voltaAssets.cuzco2}" alt="" loading="lazy">
    </div>
    <div class="volta-pala volta-pala--paris1">
      <img src="${window.voltaAssets.paris1}" alt="" loading="lazy">
    </div>
  `;

  const overlayFront = document.createElement('div');
  overlayFront.className = 'volta-mobiles-overlay volta-mobiles-overlay--front';
  overlayFront.innerHTML = `
    <div class="volta-pala volta-pala--cuzco1">
      <img src="${window.voltaAssets.cuzco1}" alt="" loading="lazy">
    </div>
    <div class="volta-pala volta-pala--paris2">
      <img src="${window.voltaAssets.paris2}" alt="" loading="lazy">
    </div>
  `;

  target.insertBefore(overlayBack, target.firstChild);
  target.appendChild(overlayFront);
});